import { render, staticRenderFns } from "./socialprofiles.html?vue&type=template&id=7bcc183f&"
import script from "./SocialProfiles.vue?vue&type=script&lang=ts&"
export * from "./SocialProfiles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports